import * as React from 'react';
import {styled} from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({}) => ({
    // height: ${(prop) => (prop.height ? prop.height : "")};
    display: "flex",
    flexDirection: " column",
    width: " 100%",
    maxWidth: "100%",
    backgroundColor: " white",
    marginTop: " 20px",
    boxShadow: " 0px 0px 20px 0px rgba(0,0,0,0.06)",
    borderRadius: " 8px",
    padding: " 10px",
    position: " relative",
    // minHeight: " 100px",
    // minHeight:${(prop) => (prop.minHeight ? prop.minHeight + "px" : "400px")},

    // border: `1px solid`,
    // '&:not(:last-child)': {
    //     borderBottom: 0,
    // },
    // '&:before': {
    //     display: 'none',
    // },
}));


export default function SimpleAccordion({header, children}) {
    return (
        <div>
            <Accordion TransitionProps={{unmountOnExit: true}}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon/>}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>{header}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {children}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}